import React from "react"
import PropTypes from "prop-types"
import Badge from "../Badge"

// constants
import { resultsFiltersMap } from "../../../../constants/assessmentResults"

const assessBadgeColorMap = {
  mandatory: "magenta",
  "not-required": "orange",
  voluntary: "seafoam",
  "insufficient-data": "gray",
  "missing-fields": "red",
}

const AssessmentResultBadge = ({
  value,
  style,
  isFlex,
  ...badgeProps // size
}) => {
  const tooltip = (value) => {
    if (value.includes("(Manual)")) return value
    return null
  }

  const colorNameKey = Object.keys(resultsFiltersMap).reduce((acc, mapVal) => {
    if (!value) return ""
    if (value.toLowerCase().includes("missing field")) return "missing-fields"
    if (value && mapVal?.toLowerCase() === value?.toLowerCase()) acc = resultsFiltersMap[mapVal]
    return acc
  }, "")

  if (!value) return null

  return (
    <Badge
      value={value && value.replace("Manual", "M")}
      colorName={assessBadgeColorMap[colorNameKey] || "gray"}
      tooltipText={tooltip(value)}
      style={style}
      isFlex={isFlex}
      {...badgeProps}
    />
  )
}

AssessmentResultBadge.propTypes = {
  value: PropTypes.string,
  style: PropTypes.object,
}

export default AssessmentResultBadge
